import React from "react";
import { useScrollPosition } from "../hooks/useScrollPosition";

const BackToTop: React.FC = () => {
  const scrollY = useScrollPosition();
  const visible = scrollY > 350;

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      className={`back-to-top${visible ? " visible" : ""}`}
      onClick={handleClick}
      aria-label="Back to top"
    >
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4l-8 8h5v8h6v-8h5z" />
      </svg>
    </button>
  );
};

export default BackToTop;
